/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_SizeInputs */

const cs_builder_prop_size = /** @type {(inputs: Builder_Prop_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velikost (pt)`)
};

const en_builder_prop_size = /** @type {(inputs: Builder_Prop_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size (pt)`)
};

/**
* | output |
* | --- |
* | "Size (pt)" |
*
* @param {Builder_Prop_SizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_size = /** @type {((inputs?: Builder_Prop_SizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_SizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_size(inputs)
	return cs_builder_prop_size(inputs)
});